import zwitCore from "./config/http";
import global from "../utils/global.js";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
const download = `${global.global.url}/zw-public/web/common/downloadArticle2`;
const downloads = `${global.global.url}/zw-public/web/common/download`
const readUrl = `${global.global.url}/zw-public/web/common/readPDFPicFile2`;
export default {
  download,
  downloads,
  readUrl,
  getPk() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-user/getPk",{withCredentials:true});
  },
  // 轮播图
  getBannerList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-knowledge/index/getBannerList");
  },
  // 推荐列表
  getItemList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/queryESListHasColler",
      data,
      false
    );
  },
  // h5精选推荐
  appPage(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/selectedRecommend/zw-knowledge/selectedRecommend/appPage",
      data,
      false
    );
  },
  // h5精选推荐
  getPromotion(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/promote/list",
      data,
      false
    );
  },
  // 中文资讯
  getListByChannel(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleInfo/getListByChannel",
      data,
      false
    );
  },
  // 合作邀约
  CooperationInvitation(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/invitation/nf/save",
      data,
      false
    );
  },
  // 学术会议列表
  getlistByColumnId(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeeting/listByColumnId",
      data,
      false
    );
  },
  //中文资讯移动端首页推荐列表
  getRecommendList(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-website/getMoreArt2", data, false);
  },
  // 百家号
  getFamilyList() {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/searchUser/nf/userList");
  },
  // 百科号
  getSectionList() {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/searchUser/nf/periodicalList"
    );
  },
  // 随机广告
  getColumnList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/advert/randomInfo",
      data,
      false
    );
  },
  getColumnLists(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/advert/advertList",
      data
    );
  },
  getHotEncyclopediasList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/geEncyclopediasList",
      data,
      false
    );
  },
  getHotFamilyList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/geHundredsList",
      data,
      false
    );
  },
  classificationOneList() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/classification/getOneList",
      {}
    );
  },
  classificationListByPid(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/classification/getListByPid",
      data,
      false
    );
  },
  hasFile(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/web/common/hasFile",
      data,
      false
    );
  },
  getWXScheme(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/promote/generatescheme",
      data,
      false
    );
  },
};
